import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getJobList } from "../../redux/actions/JobActions";
import {
  createCandidate,
  getCandidateList,
  updateCandidate,
  addCandidateAttachments,
  deleteAttachment,
} from "../../redux/actions/admin/CandidateActions";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import "moment/locale/fr";
import localStorageService from "../../services/localStorageService";
import { DropzoneArea } from "material-ui-dropzone";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import validator from "validator";
import siteService from "../../services/siteService";

const useStyles = makeStyles((theme) =>
  createStyles({
    previewChip: {
      minWidth: 160,
      maxWidth: 210,
    },
  })
);

let CandidateDocuments = (props) => {
  const { updateCandidate, addCandidateAttachments, deleteAttachment } = props;

  const closeFileDeleteModal = React.useRef();

  const currentSite = siteService.getCurrentSite();
  const [isLoading, setIsLoading] = React.useState(true);
  const [isDeletting, setIsDeletting] = React.useState(false);
  const [someTypeChanged, setSomeTypeChanged] = React.useState(false);
  const [hasMissingValue, setHasMissingValue] = React.useState(true);
  const [isUpdating, setIsUpdating] = React.useState(false);
  const [isUploading, setIsUploading] = React.useState(false);
  const [updated, setUpdated] = React.useState(false);
  const [attachmentToDelete, setAttachmentToDelete] = React.useState(null);
  const [selectedFiles, setSelectedFiles] = React.useState([]);
  const [candidatToUpdate, setCandidatToUpdate] = React.useState({
    firstName: "",
    lastName: "",
    phoneNumber1: "",
    phoneNumber2: "",
    email: "",
    password: "",
    confirmPassword: "",
    attachments: [
      {
        id: "",
        externalRepositoryId: "",
        fullName: "",
        name: "",
        dateCreated: "",
        dateModified: "",
        modificationDate: null,
        fileInfo: null,
        url: "",
        metadata: {},
        parent: null,
      },
    ],
  });

  useEffect(() => {
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    if (candidate) {
      setCandidatToUpdate(candidate);
    }

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (selectedFiles.length > 0) {
      handleAddAttachments();
    }
  }, [selectedFiles]);

  useEffect(() => {
    if (
      candidatToUpdate !== undefined &&
      candidatToUpdate.id !== undefined &&
      candidatToUpdate.id != "" &&
      isLoading == true
    ) {
      setIsLoading(false);
    }
    if (
      candidatToUpdate?.firstName == "" ||
      candidatToUpdate?.firstName === undefined ||
      candidatToUpdate?.lastName == "" ||
      candidatToUpdate?.lastName === undefined ||
      candidatToUpdate?.email == "" ||
      candidatToUpdate?.email === undefined
    ) {
      setHasMissingValue(true);
    } else if (
      candidatToUpdate?.firstName?.length > 50 ||
      candidatToUpdate?.lastName?.length > 50 ||
      candidatToUpdate?.birthPlace?.length > 50 ||
      candidatToUpdate?.phoneNumber1?.length > 50 ||
      candidatToUpdate?.phoneNumber2?.length > 50 ||
      candidatToUpdate?.email?.length > 50 ||
      // || !isMatch(candidatToUpdate?.birthDay, 'yyyy-MM-dd')
      (candidatToUpdate?.phoneNumber1 != "" &&
        !new RegExp(/^[0-9\b]+$/).test(candidatToUpdate?.phoneNumber1)) ||
      (candidatToUpdate?.phoneNumber2 != "" &&
        !new RegExp(/^[0-9\b]+$/).test(candidatToUpdate?.phoneNumber2)) ||
      (candidatToUpdate?.email != "" &&
        !validator.isEmail(candidatToUpdate?.email))
    ) {
      setHasMissingValue(true);
    } else {
      setHasMissingValue(false);
    }
  }, [candidatToUpdate]);

  const handleSubmit = () => {
    setIsUpdating(true);
    let candidat = candidatToUpdate;
    if (candidat.birthDay == "") {
      candidat.birthDay = null;
    }
    updateCandidate(candidat).then((data) => {
      if (data.success) {
        setUpdated(true);
        setCandidatToUpdate(data.candidate);
      }
      setIsUpdating(false);
    });
  };

  const handleAddAttachments = () => {
    setIsUploading(true);
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    addCandidateAttachments(candidate?.id, selectedFiles).then((data) => {
      if (data.success) {
        setCandidatToUpdate(data.candidate);
      }
      setIsUploading(false);
    });
  };

  const handleDeleteAttachment = (attachmentId) => {
    setIsDeletting(true);
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    deleteAttachment(candidate?.id, attachmentId).then((data) => {
      if (data.success) {
        setCandidatToUpdate(data.candidate);
      }
      setAttachmentToDelete("");
      closeFileDeleteModal.current.click();
      setIsDeletting(false);
    });
  };

  const handleUpdateAttachmentsType = () => {};

  // Start keydown mechanism
  let onKeydown = (event) => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      if (!hasMissingValue) {
        handleSubmit();
      }
      event.preventDefault();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", onKeydown);
    return () => {
      document.removeEventListener("keydown", onKeydown);
    };
  }, [onKeydown]);
  //End keydown mechanism

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="loading-container">
          <CircularProgress />
          <div>Chargement du formulaire en cours...</div>
        </div>
      ) : (
        <>
          <div className="col-lg-8">
            <div className="row">
              {/* Informations de base */}
              <div className="col-lg-12">
                <div className="bg-light-3 p-4">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="section-title">
                        <h2 className="title">
                          <span>Mes documents</span>
                        </h2>
                        {/* <p></p> */}
                      </div>
                    </div>
                  </div>
                  <div _lpchecked="1">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="section-title">
                          <p className="">
                            Veuillez déposer dans cette section vos documents
                            (CV, lettres de présentation, diplômes,
                            attestations, permis de conduire, etc.)
                            <strong>
                              {" "}
                              en cliquant à l'intérieur de la bande blanche
                              ci-dessous
                            </strong>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row" _lpchecked="2">
                      {isUploading ? (
                        <div className="loading-container">
                          <CircularProgress />
                          <div>Chargement des documents en cours...</div>
                        </div>
                      ) : (
                        <div className="col-lg-12">
                          <div className="form-group">
                            <DropzoneArea
                              clearOnUnmount={true}
                              dropzoneText={
                                isUploading
                                  ? "Chargement en cours..."
                                  : "Glisser ou cliquer ici pour déposer vos documents"
                              }
                              showPreviewsInDropzone={false}
                              previewGridProps={{
                                container: {
                                  spacing: 1,
                                  direction: "row",
                                },
                              }}
                              showAlerts={false}
                              maxFileSize={5000000}
                              filesLimit={10}
                              onChange={(files) => {
                                setSelectedFiles(files);
                              }}
                              onDelete={(file) => {
                                let filteredFiles = [
                                  ...selectedFiles.filter(
                                    (fi) => fi?.name != file?.name
                                  ),
                                ];
                                setSelectedFiles(filteredFiles);
                              }}
                            />
                            <p
                              style={{
                                marginTop: "9px",
                                marginBottom: "0px",
                                fontStyle: "italic",
                              }}
                            >
                              Vous pouvez ajouter jusqu'à 10 fichiers dont la
                              taille ne dépasse pas 5MB
                            </p>
                          </div>
                        </div>
                      )}
                      <div className="col-5">Nom</div>
                      <div className="col-4">Date</div>
                      <div className="col-3"></div>

                      {candidatToUpdate?.attachments?.map((file, index) => (
                        <>
                          <div className="col-5">
                            <a href={file?.url} target="_blank">
                              {file?.name}
                            </a>
                          </div>
                          <div className="col-4">
                            {moment(file?.lastModifiedDate).format(
                              "Do MM YYYY"
                            )}
                          </div>
                          <div className="col-3 text-right">
                            <a
                              href={file.url}
                              className="text-primary"
                              target="_blank"
                            >
                              <i className="fas fa-cloud-download-alt"></i>
                            </a>
                            <a
                              href="javascript:void(0)"
                              className="text-danger"
                              style={{ marginLeft: "10px" }}
                              data-toggle="modal"
                              title=""
                              data-target="#deleteAdsModal"
                              data-original-title="Delete"
                            >
                              <i
                                className="far fa-trash-alt"
                                onClick={() => setAttachmentToDelete(file)}
                              ></i>
                            </a>
                          </div>
                        </>
                      ))}
                      {someTypeChanged && (
                        <>
                          <div className="col-12 mt-4">
                            <button
                              className="btn btn-primary"
                              onClick={handleUpdateAttachmentsType}
                            >
                              Soumettre &nbsp;{" "}
                              {isUpdating ? (
                                <CircularProgress size={15} />
                              ) : (
                                <span></span>
                              )}
                            </button>
                          </div>
                          {updated && <div className="col-12 mt-4"></div>}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Start Delete file modale */}
              <div
                className="modal fade"
                id="deleteAdsModal"
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
                data-backdrop="static"
                data-keyboard="false"
              >
                <div
                  className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header p-4">
                      <h4 className="mb-0 text-center">
                        {"Suppression d'un fichier: " +
                          attachmentToDelete?.name}
                      </h4>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    <form className="mt-2">
                      <div className="modal-body">
                        <div>
                          <div className="form-row">
                            <p>
                              Êtes-vous sûr de vouloir supprimer ce fichier ?
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          data-dismiss="modal"
                          className="btn btn-primary"
                          ref={closeFileDeleteModal}
                        >
                          NON
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={(e) =>
                            handleDeleteAttachment(attachmentToDelete.id)
                          }
                          disabled={isDeletting}
                        >
                          OUI &nbsp;{" "}
                          {isDeletting ? (
                            <CircularProgress size={15} />
                          ) : (
                            <span></span>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

CandidateDocuments.propTypes = {
  getJobList: PropTypes.func.isRequired,
  createCandidate: PropTypes.func.isRequired,
  getCandidateList: PropTypes.func.isRequired,
  storeJob: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  getJobList: PropTypes.func.isRequired,
  getCandidateList: PropTypes.func.isRequired,
  createCandidate: PropTypes.func.isRequired,
  updateCandidate: PropTypes.func.isRequired,
  addCandidateAttachments: PropTypes.func.isRequired,
  deleteAttachment: PropTypes.func.isRequired,
  storeJob: state.job,
  storeEmployer: state.employer,
});

export default connect(mapStateToProps, {
  getJobList,
  createCandidate,
  getCandidateList,
  updateCandidate,
  addCandidateAttachments,
  deleteAttachment,
})(CandidateDocuments);
